export default "__VITE_ASSET__BXh5WQd0__"